import styled from "styled-components";
import { zeeguuDarkOrange } from "../../../components/colors";

const ColorAccent = styled.span`
  font-size: inherit;
  color: ${zeeguuDarkOrange};
`;

export { ColorAccent };
